export const analystPriorityDirectionEnum = {
  UP: "UP",
  DOWN: "DOWN",
  UNCHANGED: "UNCHANGED",
} as const;

export type AnalystPriorityDirection =
  (typeof analystPriorityDirectionEnum)[keyof typeof analystPriorityDirectionEnum];

export interface AnalystPriorityDirectionDisplay {
  label: string;
  icon: string | null;
}

export const analystPriorityDirectionDisplay: Record<
  AnalystPriorityDirection,
  AnalystPriorityDirectionDisplay
> = {
  UP: { label: "Up", icon: "seem-icon-arrow-up" },
  DOWN: { label: "Down", icon: "seem-icon-arrow-down" },
  UNCHANGED: { label: "Unchanged", icon: null },
};

const isKnownDirection = (
  direction: string
): direction is AnalystPriorityDirection =>
  Object.hasOwn(analystPriorityDirectionDisplay, direction);

export const getAnalystPriorityDirectionDisplay = (
  direction?: string | null
): AnalystPriorityDirectionDisplay | null =>
  !!direction && isKnownDirection(direction)
    ? analystPriorityDirectionDisplay[direction]
    : null;
